import axios from 'axios';
// import { uploadAttachment } from '../../../service/uploadFile';
import { v4 as uuidv4 } from 'uuid'
import { useEffect, useRef, useState } from 'react';
import crossImage from '../../../assets/images/cross.svg'
import { useDispatch } from 'react-redux';
import { createBrandFormActions, onboardFormActions } from '../../../store/createBrandFormState';
import { validationError } from '../../../utils/errors';
import { getImageUrl } from '../../../utils/images';
import { uploadAttachment } from '../../../service/uploadFile';

export const UploadDocumentModal = ({ show, close, docName , attachments,setAttachments}) => {
    const dispatch = useDispatch()
    const modalRef = useRef()
    const [currentDocument, setDocument] = useState({
        file: "",
        isUploading: false,
        isUploaded: false,
        progress: 0,
        url: "",
        name: ""
    });

    const [customDocName, setCustomDocName] = useState("")

    const getAttachement = async (e) => {
        console.log(e)
        const fileExt = e.target.files[0].name.split(".")[1].toLowerCase() || "txt";
        console.log("fileExt",fileExt)
        if (e.target.files[0].size > 50000000) {
            return validationError("File size not allowed","You can only upload files under 50mb")
        }
        if (fileExt !== "pdf") {
            return validationError("Unsupported Media","Only pdf files are supported.")
        }
        const file = e.target.files[0];
        console.log("e.target.files",e.target.files)
        // console.log("file",file)
        file.isUploading = true;
        file.cancelToken = axios.CancelToken.source();
        const path = (window.URL || window.webkitURL).createObjectURL(
            e.target.files[0]
        );
        file.path = path;
        console.log("file",file)
        setDocument({
            file: file,
            isUploading: false,
            isUploaded: false,
            progress: 0,
            url: path,
            name: e.target.files[0].name
        });
      
       
    };

    const removeAttachment = () => {
        setDocument({
            isUploading: false,
            isUploaded: false,
            progress: 0,
            url: "",
        });
    }

    const uploadDoc = async () => {
        const file = currentDocument.file
        const fileExt = file.name.split(".")[1].toLowerCase() || "txt";
        const uniqueName = uuidv4() + "." + fileExt
        const fileData = new FormData();
        fileData.append("file", new File([currentDocument.file], uniqueName));
        const response = await uploadAttachment(
            fileData,
            setDocument,
            file.cancelToken
        );
        if (response.data) {
            console.log("response",response)
            if (docName != "") {
                dispatch(createBrandFormActions.updateMandatoryAndOptionalDoc({ id: docName, url: currentDocument.url, docId: response.data.id }))
               
            } else {
                dispatch(createBrandFormActions.addAttachments({ id: response.data.id, url: currentDocument.url, docId: response.data.id, name: customDocName }))
                setAttachments([...attachments,{ attachments:{name: response.data.fileName, url: currentDocument.url, id: response.data.id} }])
            }
            close()
        }
        
    }

    useEffect(() => {
        if (show) {
            document.getElementsByTagName("body")?.[0]?.classList.add("modal-open")
            setTimeout(() => {
                document.getElementById("upload-document")?.classList.add("show")
            }, 100)
        }
        else {
            document.getElementsByTagName("body")?.[0]?.classList.remove("modal-open")
        }

        setDocument({
            file: "",
            isUploading: false,
            isUploaded: false,
            progress: 0,
            url: "",
            name: ""
        })

    }, [show])

    useEffect(() => {
        const handler = (event) => {
            if (!modalRef.current) {
                return;
            }
            if (modalRef.current == event.target) {
                close();
            }
        };
        document.addEventListener("click", handler, true);
        return () => {
            document.removeEventListener("click", handler);
        };
    }, []);

    return (
        show ?
            <div>
                <div
                    className="modal fade"
                    id="upload-document"
                    aria-modal="true"
                    role="dialog"
                    style={{ display: "block" }}
                    ref={modalRef}
                >
                    <div className="modal-dialog">
                        <div className="modal-content rounded-15">
                            <div className="modal-body px-70 py-40">
                                <p className="mb-1 font-20 font-weight-800">
                                    {docName == "" ? "Upload additional document" : "Upload document"}
                                </p>
                                <p className="opacity-70">
                                Please upload documents for each listed category.
                                </p>
                                <div className="row form-default">
                                    <div className="col-12 col-md-12">
                                        {currentDocument.url == "" && <div className="form-group fileDragDrop mt-3 mb-50">
                                            <div className="inputFile">
                                                <input type="file" className="form-control" onChange={getAttachement} onClick={e => e.target.value = null}  accept='.pdf'/>
                                            </div>
                                            <p className="font-weight-600 broken-top-70 text-center">
                                                Drag &amp; drop files or{" "}
                                                <span className="text-light-default">browse</span>
                                            </p>
                                            <p className="font-10 broken-top-10 text-center">
                                                Supported formates: PDF only
                                            </p>
                                        </div>
                                        }

                                        {currentDocument.url != "" &&
                                            <div> <iframe className='mt-3 mb-50' style={{ border: "none", width: "100%" }} src={currentDocument.url} />

                                                <div className="form-group form-file position-relative">
                                                    <label className="text-dark opacity-70">Upload</label>
                                                    <span className="icon-cross" onClick={removeAttachment}>
                                                        <img src={getImageUrl("cross.svg")} alt="img" />
                                                    </span>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        defaultValue={currentDocument.name}
                                                        disabled
                                                    />
                                                    {currentDocument.isUploading && <div className="progress mt-1">
                                                        <div
                                                            className="progress-bar"
                                                            role="progressbar"
                                                            style={{ width: `${currentDocument.progress}%` }}
                                                            aria-valuenow={60}
                                                            aria-valuemin={0}
                                                            aria-valuemax={100}
                                                        />
                                                    </div>
                                                    }
                                                </div>
                                                {docName == "" && <div className="form-group mb-4">
                                                    <label>Document name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter the name of the document"
                                                        onChange={(e) => setCustomDocName(e.target.value)}
                                                    />
                                                </div>
                                                }
                                                <button type="button" className="btn btn-default w-100" onClick={uploadDoc} disabled={currentDocument.isUploading ? true : false}>
                                                    {currentDocument.isUploading ? "Uploading" : "Upload"}
                                                </button>
                                            </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`modal-backdrop fade ${show && "show"}`} />

            </div> : <div></div>

    )
}